import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { OfferService } from 'app/shared/services/offer/offer.service';

@Component({
  selector: 'app-image-offer',
  templateUrl: './image-offer.component.html',
  styleUrls: ['./image-offer.component.scss']
})
export class ImageOfferComponent implements OnInit, OnChanges {

  @Input() offerKey: number;
  @Input() width: number;
  @Input() height: string;
  @Input() matCard: boolean;
  src: any;

  isLoading = false;

  constructor(
    private offerService: OfferService,

    private domSanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.offerKey.currentValue) {
      this.getImage(changes.offerKey.currentValue);
    }
  }

  private getImage(offerKey: number) {
    this.isLoading = true;
    this.offerService.getImgOffer(offerKey).subscribe({
      next: image => {
        this.src = this.domSanitizer.bypassSecurityTrustUrl(`data:image/png;base64, ${image.pictureBase64}`);
        this.isLoading = false;
      }
    });
  }

}
